module.exports = __webpack_public_path__ + "static/media/ice_cream@2x.07dd40ad.png";